// hooks/usePersianMoment.ts
import { useEffect } from 'react';
import moment from 'moment-jalaali';
import 'moment/locale/fa';

export function usePersianMoment(currentLanguage: string) {
  useEffect(() => {
    if (currentLanguage === 'fa') {
      moment.loadPersian({
        dialect: 'persian-modern',
        usePersianDigits: true  // This enables Persian digits
      });
      moment.locale('fa');
    } else {
      moment.locale('en');
    }
  }, [currentLanguage]);
}
